/* eslint-disable react-hooks/exhaustive-deps */
import './index.css'
import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import MainLayout from 'layouts/mainLayout'

// import ZendeskLink from 'components/Common/ZendeskLink'
import Header from 'components/Common/Header'
// import IdleTimer from 'components/Common/IdleTimer'

import TabBar from 'components/Vault/TabBar'
import VaultDocuments from 'components/Vault/VaultDocuments'
import VaultBOD from 'components/Vault/VaultBOD'

import routes from 'routes'
import { VaultAPI } from 'api'
import ZendeskLink from 'components/Common/ZendeskLink'

const TabItems = [
  {
    item: 'Documents',
    content: <VaultDocuments />,
  },
  { item: 'Beneficial Ownership Details', content: <VaultBOD /> },
]
const VaultLayout = props => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [selected, setSelected] = useState('Documents')

  const defaultBusinessId = useSelector(state => state.apiResponseReducers.defaultBusinessId)
  const vaultSummary = useSelector(state => state.vaultReducer.vaultSummary)

  const handleSelectTab = tabItem => {
    if (tabItem === selected) return
    setSelected(tabItem)
  }

  const getTabContent = () => {
    const index = TabItems.findIndex(e => e.item === selected)
    if (index === -1) return null
    else return TabItems[index].content
  }
  useEffect(() => {
    // NOTE: companyId is coming from the authed user info
    if (!defaultBusinessId) {
      return
    }
    if (!vaultSummary.vault_verified) {
      navigate(routes.home)
    }

    VaultAPI.fetchVaultSummary(dispatch, defaultBusinessId)
  }, [defaultBusinessId, vaultSummary.vault_verified])

  return (
    <MainLayout>
      {/* <IdleTimer maxIdleTime={process.env['REACT_APP_MAX_IDLE_TIME_VAULT']} /> */}
      <Header title={'Vault'}></Header>
      <div className="vault-tab-wrapper p-3">
        <TabBar items={TabItems.map(e => e.item)} onClickItem={handleSelectTab} selected={selected} />
        {getTabContent()}
      </div>
      <ZendeskLink />
    </MainLayout>
  )
}

export default VaultLayout
